import { Container } from "../containers/Container";
import { borderFill } from "../helpers";
import { ComponentF, ComponentO, createElement } from "../ui";

export const Panel: ComponentF<{ children: ComponentO[] }> = (C, props) => {
  borderFill(C.display, C.bounds);
  return [
    createElement(
      Container,
      { x: 1, y: 1, w: C.bounds.w - 2, h: C.bounds.h - 2 },
      props
    ),
  ];
};
